export default __webpack_public_path__ + "static/media/map-pin.c806b274.svg";